import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import { formatDate, parseDateStr } from '@hotelplan/libs.utils';
import { FdrAgencySpecialHours } from '@hotelplan/supergraph-api';

const WEEKDAYS_NAMES = [
  'common:week.shorten.monday',
  'common:week.shorten.tuesday',
  'common:week.shorten.wednesday',
  'common:week.shorten.thursday',
  'common:week.shorten.friday',
  'common:week.shorten.saturday',
  'common:week.shorten.sunday',
];

function formatLongTime(longTime: string): string {
  const [hours, minutes] = longTime.split(':');
  return `${hours}:${minutes}`;
}

interface IFdrSpecialHoursBlockProps {
  specialHours: Array<FdrAgencySpecialHours>;
}

export function FdrSpecialHoursBlock({
  specialHours,
}: IFdrSpecialHoursBlockProps): ReactElement {
  const [t, { language }] = useTranslation('agency');

  return (
    <>
      <div>{t('agency:specialOpeningHours.title')}</div>
      {specialHours.map((item, index) => {
        if (!item) return null;

        return (
          <div key={index}>
            {item.date ? (
              <div className="schedule-name">
                {`${formatDate(parseDateStr(item.date), 'EE', language).slice(
                  0,
                  -1
                )}, ${formatDate(parseDateStr(item.date), 'dd.MM.yyyy')}:
              `}
                {!item.closed
                  ? item.shifts
                      ?.map(({ from, to }) =>
                        to
                          ? t('agency:openingHours.shift', {
                              from: formatLongTime(from),
                              to: formatLongTime(to),
                            })
                          : t('agency:openingHours.from', {
                              from: formatLongTime(from),
                            })
                      )
                      .join(' / ')
                  : t('agency:openingHours.closed')}
              </div>
            ) : (
              t(WEEKDAYS_NAMES[index])
            )}
          </div>
        );
      })}
    </>
  );
}
